import React from 'react';
import styles from './UnserTeam.module.css';

const UnserTeam = () => {
    return (
        <div className={`${styles.root} wrapperSM`}>
            <section className={styles.section}>
                <h1 className={styles.heading}>
                    Sie möchten Teil unseres Teams werden und Karriere an der IKS Rhein-Main machen?
                </h1>
                <p className={styles.paragraph}>
                    Bewerben Sie sich jetzt, wenn Sie Interesse am täglichen Kontakt mit Menschen und wissbegierigen
                    Schülerinnen und Schülern haben oder sich den Aufgaben Schuldigitalisierung, Marketing einer
                    Privatschule oder Schulverwaltung zuwenden möchten. Wir freuen uns auf Ihre Bewerbung!
                </p>
             <a
               href="mailto:info@iks-schule.de"
               className={styles.buttonn}
             >
               E-Mail senden!
             </a>

            </section>
        </div>
    );
};

export default UnserTeam;
